import { render, staticRenderFns } from "./HelpCenterStatistics.vue?vue&type=template&id=4a898d21&scoped=true"
import script from "./HelpCenterStatistics.vue?vue&type=script&lang=js"
export * from "./HelpCenterStatistics.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterStatistics.vue?vue&type=style&index=0&id=4a898d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a898d21",
  null
  
)

export default component.exports